import { useAuthStore } from "src/stores/auth-store";
import { useSettingsStore } from "src/stores/settings-store";

export function logEvent(name: EVENTS, data?: any) {
  //@ts-ignore
  window.dataLayer = window.dataLayer || []
  //@ts-ignore
  window.dataLayer.push({
    event: "customEvent",
    dealerId: useAuthStore().affiliateUserId,
    eventName: name,
    eventData: JSON.stringify(data)
  })

}

export enum EVENTS {
  LOGIN = "login",
  LOGIN_FAIL = "login_fail",
  LOGOUT = "logout",
  ELIGIBILITY_CREATE_NEW = "eligibility_create_new",
  ENQUIRY_CREATE_NEW = "enquiry_create_new",
  PASSWORD_FORGOT = "password_forgot",
  PASSWORD_FORGOT_FAIL = "password_forgot_fail",
  PASSWORD_RESET = "password_reset",
  PASSWORD_RESET_FAIL = "password_reset_fail",
  PROPOSAL_FILTER = "proposal_filter",
  PROPOSAL_FILTER_RESET = "proposal_filter_reset",
  PROPOSAL_VIEW = "proposal_view",
  PROPOSAL_NEW_VIEW = "proposal_new_view",
  PROPOSAL_NEW_SUCCESS = "proposal_new_success",
  PROPOSAL_NEW_FAIL = "proposal_new_fail",
  PROPOSAL_REAPPLY_VIEW = "proposal_reapply_view",
  PROPOSAL_REAPPLY_SUCCESS = "proposal_reapply_success",
  PROPOSAL_CREATE_NEW = "proposal_create_new",
  PROPOSAL_REAPPLY_FAIL = "proposal_reapply_fail",
  APPLICATION_DETAILS_VIEW = "application_details_view",
  QUICK_QUOTE_VIEW = "quick_quote_view",
  QUICK_QUOTE_CREATE = "quick_quote_create",
  QUICK_QUOTE_FAIL = "quick_quote_fail",
  QUICK_QUOTE_CONVERT = "quick_quote_convert",
  QUICK_QUOTE_CONVERT_VIEW = "quick_quote_convert_view",
  QUICK_QUOTE_CONVERT_SUCCESS = "quick_quote_convert_success",
  QUICK_QUOTE_CONVERT_FAIL = "quick_quote_convert_fail",
  QUICK_QUOTE_CREATED = "quick_quote_created",
  QUOTES_VIEW = "quotes_view",
  QUOTES_EXPANDED = "quotes_expanded",
  QUOTES_DETAILS = "quote_details",
  QUOTE_SEND_WHATSAPP = "quote_send_whatsapp",
  QUOTE_SEND_SMS = "quote_send_sms",
  QUOTE_PROCEED = "quote_proceed",
  QUOTE_SENT_TO_CUSTOMER = "quote_sent_to_customer",
  NOTES_VIEW = "notes_view",
  NOTE_CREATE = "note_create",
  NOTE_CREATE_FAIL = "note_create_fail",
  DOCUMENTS_VIEW = "documents_view",
  DOCUMENT_UPLOAD = "document_upload",
  DOCUMENT_UPLOAD_FAIL = "document_upload_fail",
  HELP_VIEW = "help_view",

  STOCK_SET_BUDGET = "stock_set_budget",
  STOCK_SET_TERM = "stock_set_term",
  STOCK_SET_SCORE = "stock_set_score",
  STOCK_SET_DEPOSIT = "stock_set_deposit",
  STOCK_SET_PX = "stock_set_px",
  STOCK_SET_SETTLEMENT = "stock_set_settltment",
  STOCK_SET_MILEAGE = "stock_set_mileage",
  STOCK_PRICE_DETAILS_VIEWED = "stock_price_details_viewed",
  STOCK_APPLY_CLICK = "stock_apply_click",
  STOCK_APPLY_SUCCESS = "stock_apply_success",
  STOCK_FEED_OPENED = "stock_feed_opened",

  STOCK_CREATE_PROPOSAL = "stock_create_proposal",

  VALUATION_CREATED = "valuation_created",

}
